const billingStatus = [
  { id: 1, name: 'Por Facturar' },
  { id: 2, name: 'Facturado' },
  { id: 3, name: 'Pagado' },
  { id: 4, name: 'Proforma Factura' },
  { id: 5, name: 'Libre De Cobro' },
  { id: 6, name: 'Nota De Crédito' },
  { id: 7, name: 'Mensual - Por Facturar' },
  { id: 8, name: 'China Facturar' },
  { id: 9, name: 'Pendiente' },
  { id: 10, name: 'Cancelado' },
  { id: 11, name: 'Enviado A Facturar' }
]

export default billingStatus
